






























































































































import Vue from 'vue';
import { FormFieldValidation, RouteHelpers } from '@/mixins';
import { DocuSignAdditionalDocumentSignTabCreateUpdateModel, BaseResultModel, ValueType } from '@/types';
import { DocuSignConfigurationService } from '@/services/docuSign/DocuSignConfigurationService';
import SnotifyConfiguration from '@/classes/SnotifyConfiguration';
import LoadingSpinner from '@/components/shared/LoadingSpinner.vue';
import { ValidationModel } from '@/types/models/validation';

export default Vue.extend({
  name: 'DocusignEditAdditionalDocumentSignTab',
  mixins: [FormFieldValidation, RouteHelpers],
  data() {
    return {
      isLoading: false,
      pageNumber: '',
      xCoord: '',
      yCoord: '',
      includeDateSigned: false,
      dateSignedXCoord: '',
      dateSignedYCoord: '',
      additionalDocumentSignTab: {} as DocuSignAdditionalDocumentSignTabCreateUpdateModel,
      submitIsLoading: false,
      hasError: false,
      errorMessage: ''
    };
  },
  methods: {
    getData(this: any) {
      this.getSignTabAsync(this.$route.params.id);
    },
    async onSubmit(this: any) {
      this.resetFormValidation();
      try {
        const isValid = await this.$validator.validate();
        if (isValid) {
          this.submitIsLoading = true;
          this.additionalDocumentSignTab.pageNumber = Number(this.pageNumber);
          this.additionalDocumentSignTab.xCoord = Number(this.xCoord);
          this.additionalDocumentSignTab.yCoord = Number(this.yCoord);
          this.additionalDocumentSignTab.includeDateSigned = Number(this.includeDateSigned);
          this.additionalDocumentSignTab.dateSignedXCoord = Number(this.dateSignedXCoord);
          this.additionalDocumentSignTab.dateSignedYCoord = Number(this.dateSignedYCoord);

          const result: BaseResultModel = await DocuSignConfigurationService.updateAdditionalDocumentSignTabAsync(this.additionalDocumentId, this.signTabId, this.additionalDocumentSignTab);

          if (result.hasNotification && !result.showToast) {
            this.addFormValidationError(result.notification);
            this.submitIsLoading = false;
            return;
          }

          SnotifyConfiguration.showSuccess('Additional document sign tab updated successfully.');
          this.setApplicationDirty(false);
          this.navigateToSignTabManagement();
        }
      } catch (error) {
        this.$log('Error updating additional document sign tab', error);
      } finally {
        this.submitIsLoading = false;
      }
    },
    async getSignTabAsync(this: any, id: number) {
      this.isLoading = true;
      try {
        this.additionalDocumentSignTab = await DocuSignConfigurationService.getAdditionalDocumentSignTabAsync(this.additionalDocumentId, id);
        this.pageNumber = String(this.additionalDocumentSignTab.pageNumber);
        this.xCoord = String(this.additionalDocumentSignTab.xCoord);
        this.yCoord = String(this.additionalDocumentSignTab.yCoord);
        this.includeDateSigned = this.additionalDocumentSignTab.includeDateSigned;
        this.dateSignedXCoord = String(this.additionalDocumentSignTab.dateSignedXCoord ?? 0);
        this.dateSignedYCoord = String(this.additionalDocumentSignTab.dateSignedYCoord ?? 0);
      } catch (error) {
        this.additionalDocumentSignTab = {} as DocuSignAdditionalDocumentSignTabCreateUpdateModel;
        this.$log('Error getting additional document sign tab');
      } finally {
        this.isLoading = false;
      }
    },
    onCancel(this: any) {
      this.navigateToSignTabManagement();
    },
    navigateToSignTabManagement(this: any) {
      this.navigateToRoute('docusignAdditionalDocumentSignTabManagement', this.additionalDocumentId);
    }
  },
  computed: {
    additionalDocumentId(): number {
      return Number(this.$route.params.additionalDocumentId);
    },
    signTabId(): number {
      return Number(this.$route.params.id);
    },
    headerText(this: any) {
      return this.additionalDocumentSignTab.tabName ? `Edit Additional Document Sign Location (${this.additionalDocumentSignTab.tabName})` : 'Edit Additional Document Sign Location';
    }
  },
  created(this: any) {
    this.pageNumberValidation = {
      required: true,
      valueType: ValueType.Integer,
      minValue: 1,
      maxValue: 100
    } as ValidationModel;
    this.coordValidation = {
      required: true,
      valueType: ValueType.Integer,
      minValue: 0,
      maxValue: 10000
    } as ValidationModel;
    this.getData();
  },
  components: {
    LoadingSpinner
  }
});
